// BookingHelper.js
class BookingHelper {
   
    static fixAndUpdateSession(bookingData) {
        try {
            debugger;
            const sessionData = JSON.parse(bookingData.sessionData);

            sessionData.recommendedOpenModals.forEach((item) => {
                const found = bookingData.activities.find(
                    w => w.activityId === item.id && item.isVelgClick && !w.isDeleted && !w.isCanceled
                );

                if (!found) {
                    item.isVelgClick = false;
                }
            });

            sessionData.widget = sessionData.widget.filter((item) => {
                const found = bookingData.activities.find(
                    w => w.activityId === item.id && item.isVelgClick && !w.isDeleted && !w.isCanceled
                );
                return Boolean(found);
            });


            bookingData.SessionData = JSON.stringify(sessionData);

            return bookingData;
           
        } catch (error) {
            console.error("Error in fixAndUpdateSession:", error);
        }
    }



    static areActivitiesSame  (a1 = [], a2 = [])  {
        if (a1.length !== a2.length) return false;

        debugger;
        const normalizeTime = (time) => (time ? time.toString().slice(0, 5) : "");
        const normalizeDate = (date) => (date ? date.toString().split("T")[0] : "");

        for (let i = 0; i < a1.length; i++) {
            const act1 = a1[i];
            const act2 = a2[i];

            if (
                act1.activityId !== act2.activityId ||
                act1.activityName !== act2.activityName ||
                normalizeDate(act1.activityDate) !== normalizeDate(act2.activityDate) ||
                normalizeTime(act1.timeFrom) !== normalizeTime(act2.timeFrom) ||
                normalizeTime(act1.timeTo) !== normalizeTime(act2.timeTo) ||
                act1.personCount !== act2.personCount ||
                act1.pricePerPerson !== act2.pricePerPerson
            ) {
                return false;
            }
        }
        return true;
    };

  
    
}

export default BookingHelper;
